import * as React from 'react';
import i18n from 'src/translation/i18n';
import { goToHome, goToPartClaim } from 'src/utils/navigation';

import OrderMissingPart from '../../pages/OrderMissingPart';
interface IDamagesubmittedPageprops {
  claimNumber: string;
  gotodamageClaim: () => void;
  backToDashBoard:()=> void;
}
interface IDamagesubmittedPagestate {
  anotherClaim: boolean;
}
class OrderMissingPartsubmittedPage extends React.Component<
  IDamagesubmittedPageprops,
  IDamagesubmittedPagestate
> {
  constructor(props: any) {
    super(props);
    this.state = {
      anotherClaim: false
    };
  }
  private gotodamageClaim = () => {
    this.setState({
      anotherClaim: true
    });
    this.props.backToDashBoard();
  };
  public render() {
    return (
      <>
        {this.state.anotherClaim ? (
          <OrderMissingPart />
        ) : (
          <div className="rp-part-claim--confirmation">
            <div className="rp-part-claim--confirmation-info">
              <i className="rpds-check-circle rp-part-claim--success-icon-desktop" />
              <div>
                <div className="rp-part-claim--confirmation-title">
                  {i18n.t('partClaim.claimsubmitted')}
                </div>
                <i className="rpds-check-circle rp-part-claim--success-icon-mobile" />
                <p className="rp-part-claim--confirmation-description">
                  {/* Thank you! You will be contacted by a Reliable Parts Customer
              Service Representative soon. */}
                  {i18n.t('partClaim.submittedsuccessfully')}{' '}
                  {this.props.claimNumber} {i18n.t('partClaim.shortly')}
                </p>
              </div>
            </div>
            <div className="rp-part-claim-divider" />
            <div className="d-flex submit-wraper">
              <button
                onClick={e => goToHome()}
                className="primary-button rp-part-claim--confirmation-buttons"
              >
                Go Home
              </button>
              <button
                onClick={e => this.gotodamageClaim()}
                className="primary-button rp-part-claim--confirmation-buttons"
              >
                Submit another claim
              </button>
            </div>
          </div>
        )}
      </>
    );
  }
}
export default OrderMissingPartsubmittedPage;
